import script from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationCard.vue?vue&type=style&index=0&id=32b1de28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b1de28"]])

export default __exports__